var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"test-grid-overlay"},_vm._l((12),function(n){return _c('div',{staticClass:"test-grid-overlay__column"})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }